module.exports = "<p>\n  quote works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home3/usalinks/public_html/ally-book-source/src/app/quote/quote.component.html
// module id = ../../../../../src/app/quote/quote.component.html
// module chunks = main